import { useMockLocation } from './useMockLocation'
import styles from './MockLocation.module.scss'

export default function MockLocation() {
  const {
    showAlert,
    coords,
    nearestLocation,
    hasMockLocation,
    clearMockLocation,
  } = useMockLocation()
  const { city, state, country } = nearestLocation || {}
  if (!showAlert || !hasMockLocation || !coords) return null

  return (
    <div className={styles.mockLocation}>
      <div className={styles.info}>
        <strong>Using Mock Location: </strong>

        {nearestLocation && (
          <span>
            {city}
            {state ? `, ${state}` : ''}
            {country ? `, ${country}` : ''}
          </span>
        )}
      </div>

      <button
        className={styles.close}
        onClick={clearMockLocation}
        aria-label="Clear mock location"
      >
        X
      </button>
    </div>
  )
}
